<template>
    <div v-if="data">
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Outbound Delivery</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="editMode = true" v-if="!editMode" icon="edit">Edit</vs-button>
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="createDo" v-if="!editMode" icon="file_copy">Create Delivery Order</vs-button>
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="submitForm" v-if="editMode" icon="save">Save</vs-button>
                        <vs-button @click="printOdNote" class="mb-4 btn md:mb-0" icon="print" v-if="!editMode">Print</vs-button>
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col lg:w-1/5">
                    <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Outbound ID*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.id" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Outbound Reference*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.outbound_reference" :disabled="!editMode"/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Request Delivery Date*
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.req_del_date" :disabled="!editMode || !editable"/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client ID
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/5">
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Transporter ID*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.transporter_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, transporter)"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Service Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.service_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, service_type)"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in service_type.data" :key="index" :value="item.id" :text="item.service_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Payment Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.payment_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, payment_type)"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in payment_type.data" :key="index" :value="item.id" :text="item.payment_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Price
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.price" :disabled="!editMode"/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/5">
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Business Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.business_type_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in business_type.data" :key="index" :value="item.id" :text="item.code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Origin*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.origin_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    @change="setOrigin()"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Address
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.origin_address_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.origin_address_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/5">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Order Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.order_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_type)"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Destination
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.destination_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    @change="setDestination()"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Address
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.destination_address_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.destination_address_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/5">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Outbound Status
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.status" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mb-4 vx-row">
                            <div class="w-1/3 vx-col">
                                Order Date
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.po_date" :disabled="!editMode"/>
                            </div>
                        </div>
                        <!-- <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Order Source
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.order_source_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in client.order_source" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div> -->
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Order Source
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.order_source_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_source)"
                                    :disabled="!editMode || !editable"
                                >
                                    <vs-select-item v-for="(item, index) in order_source.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                         <div class="mb-3 vx-row">
                    <div class="w-1/3 vx-col">
						Attachment
					</div>
                    <div class="w-2/3 vx-col">
                <input
              type="file"
              id="file_name"
              v-on:change="handleFileUpload($event)" :disabled="!editMode"
            />
            </div>
        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Item Details">
                        <vs-button @click="addItem" class="mt-5 mb-5 mr-1 btn" :disabled="!editMode || !editable" type="border">Add</vs-button>
                        <vs-button class="mt-5 mr-1 btn" @click="removeDetail()" :disabled="selected.length < 1 || !editMode || !editable" type="border">Remove</vs-button>
                        <vs-table v-model="selected" :data="data.details" hoverFlat class="mt-5" multiple pagination max-items="20">
                            <template slot="thead">
                                <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                                <vs-th style="min-width: 120px;">Warehouse ID</vs-th>
                                <vs-th style="min-width: 120px;">Product ID</vs-th>
                                <vs-th style="min-width: 120px;">Description</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">UoM</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Committed Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" :state="detail.data_status == 'delete' ? 'danger' : null">
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.line_id" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.warehouse_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDropdown($event, warehouse)"
                                            :disabled="!editMode || !editable"
                                        >
                                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.product_id"
                                            width="100%"
                                            autocomplete
                                            @change="getProduct(detail)"
                                            @input-change="searchProductClient($event)"
                                            :disabled="!editMode || !editable"
                                        >
                                            <vs-select-item v-for="(item, index) in products" :key="index" :value="item.id" :text="item.product_code"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.description" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.pack_id" :disabled="!editMode || !editable"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.batch" :disabled="!editMode || !editable"/>
                                    </vs-td>
                                    <vs-td>
                                        <flat-pickr class="w-full" v-model="detail.expired_date" :disabled="!editMode || !editable"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.qty" :danger="detail.qtyError" @input="convertQty(detail); validateQty(detail)" :disabled="!editMode || !editable"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.uom_id"
                                            width="100%"
                                            autocomplete
                                            @change="convertQty(detail)"
                                            :disabled="!editMode || !editable"
                                        >
                                            <vs-select-item v-for="(item, index) in detail.uoms" :key="index" :value="item.id" :text="item.name" />
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.stock_type_id"
                                            width="100%"
                                            autocomplete
                                            :disabled="!editMode || !editable"
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.committed_qty" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.base_qty" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.base_uom_id"
                                            width="100%"
                                            autocomplete
                                            :disabled="true"
                                        >
                                            <vs-select-item v-for="(item, index) in detail.uoms" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Custom">
                        <div class="mt-6 vx-row">
                            <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        AJU Number
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.aju_number" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mt-1 mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        SPPB Number
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.sppb_number" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mt-1 mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        SPPB Date
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <flat-pickr class="w-full" v-model="data.custom.sppb_date" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mt-5 mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        BL/AWB
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.blorawb" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Registration Number
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.registration_number" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Registration Date
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <flat-pickr class="w-full" v-model="data.custom.registration_date" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mt-1 mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Invoice Number
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.invoice_number" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                            </div>
                             <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        No Kendaraan
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.nokendaraan" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                       Nama Supir
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.namasupir" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                                <div class="mt-1 mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        No Hp
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.custom.nohp" :disabled="editMode ? false : true"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Notes">
                        <vs-textarea height="200" class="mt-5" :disabled="editMode ? false : true" label="Notes" v-model="data.remark"/>
                    </vs-tab>
                    <vs-tab label="Attachment">
                        <vs-table :data="attachments">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="mb-4 mr-1 btn md:mb-0" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="mb-4 mr-1 btn md:mb-0" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                data: {
                    id: '',
                    outbound_reference: '',
                    req_del_date: null,
                    client_id: null,
                    transporter_id: null,
                    service_type_id: null,
                    payment_type_id: null,
                    price: '',
                    business_type_id: null,
                    origin_id: null,
                    origin_address_1: '',
                    origin_address_2: '',
                    destination_id: null,
                    destination_address_1: '',
                    destination_address_2: '',
                    order_type_id: null,
                    status: '',
                    po_reference: '',
                    po_date: null,
                    order_source_id: null,
                    details: [],
                    custom: {
                        aju_number: '',
                        sppb_number: '',
                        sppb_date: null,
                        blorawb: '',
                        registration_number: '',
                        registration_date: null,
                        invoice_number: '',
                        nokendaraan: '',
                        namasupir: '',
                        nohp:''
                    }
                },
                selected: [],
                editMode: false,
                editable: true,
                edit: {
                    reference: false,
                    req_del_date: false,
                    order_type: false,
                    client: false,
                    po_reference: false,
                    po_date: false,
                    origin: false,
                    destination: false,
                    detail: {
                        warehouse: false,
                        product: false,
                        pack_id: false,
                        batch: false,
                        expired_date: false,
                        qty: false,
                        stock_type: false
                    }
                },
                outbound_status: null,
                isLoading: false,
                detailsCount: 0,
                client_id: null,
                origin_id: null,
                destination_id: null,
                order_type_id: null,
                transporter_id: null,
                service_type_id: null,
                payment_type_id: null,
                business_type_id: null,
                attachments: [
                ],
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                business_type: {
                    data: [],
                },
                order_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes',
                    objectKey: 'order_type'
                },
                transporter: {
                    data: [],
                    loading: false,
                    endpoint: 'master/transporters',
                    objectKey: 'transporter_code'
                },
                service_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/servicetypes',
                    objectKey: 'service_type'
                },
                order_source: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordersources',
                    objectKey: 'name'
                },
                payment_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/paymenttypes',
                    objectKey: 'payment_type'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
                warehouse: {
                    data: [],
                    loading: false,
                    endpoint: 'master/warehouses',
                    objectKey: 'warehouses_code'
                },
                products: [],
                // order_source: {
                //     data: []
                // }
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            handleFileUpload(event){
            this.file = event.target.files[0];
            },
            submitForm() {
                let error = false
                this.data.details.map(item => {
                    if(item.base_qty < item.committed_qty) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Line ' + item.line_id + ' - Base qty cannot be lower than committed qty'
                        })
                        error = true
                    }
                })

                if(error) {
                    return false
                }

                // const data = {
                //     outbound_reference: this.data.outbound_delivery.outbound_reference,
                //     req_del_date: this.data.outbound_delivery.req_del_date,
                //     order_type_id: this.data.outbound_delivery.order_type_id,
                //     client_id: this.data.outbound_delivery.client_id,
                //     po_reference: this.data.outbound_delivery.po_reference,
                //     po_date: this.data.outbound_delivery.po_date,
                //     origin_id: this.data.outbound_delivery.origin_id,
                //     destination_id: this.data.outbound_delivery.destination_id,
                //     business_type: this.data.outbound_delivery.business_type,
                //     service_type_id: this.data.outbound_delivery.service_type_id,
                //     transporter_id: this.data.outbound_delivery.transporter_id,
                //     remark: this.data.outbound_delivery.remark
                // }

                this.isLoading = true

                this.$http.put('outbound/outbounddelivery/' + this.$route.params.id + '/update', this.data)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Updated successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Outbound updated'
                    })
                    this.isLoading = false
                    this.editMode = false
                    this.fetchAllData()
                })
                .catch(error => this.handleError(error));
             let document_send = {
                module_id:this.$route.params.id,
                module_name:'outbound'
            };
            let file = new FormData();
            file.append("file_name",this.file);
            this.$http.post('/attachment/uploads',file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },
              params: document_send
            })
            .then((resp) => {
                // this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false
                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Attachment Succesfully'
                });


            })
            .catch((error) =>{
                this.isLoading = false
            });
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.push({name: 'outbound-delivery'}),
                    })
                }
                else{
                    this.$router.push({name: 'outbound-delivery'})
                }
            },
            combineLine() {
                const details = []
                let found = false

                this.data.details.map(item => {
                    if(details.length >= 1) {
                        for(let i = 0; i < details.length; i++) {
                            if(details[i].product_id == item.product_id && details[i].stock_type_id == item.stock_type_id && details[i].uom_id == item.uom_id && details[i].pack_id == item.pack_id && details[i].expired_date == item.expired_date && details[i].batch == item.batch && details[i].data_status == item.data_status) {
                                details[i].qty = parseInt(details[i].qty) + parseInt(item.qty)
                                found = true

                                break
                            }

                        }

                        if(!found) {
                            details.push({
                                id: item.id,
                                warehouse_id: item.warehouse_id,
                                line_id: item.line_id,
                                product_id: item.product_id,
                                pack_id: item.pack_id,
                                batch: item.batch,
                                expired_date: item.expired_date,
                                qty: item.qty,
                                uom_id: item.uom_id,
                                stock_type_id: item.stock_type_id,
                                base_uom_id: item.base_uom_id,
                                data_status: item.data_status,
                            })
                        }
                    }
                    else {
                        details.push({
                            id: item.id,
                            warehouse_id: item.warehouse_id,
                            line_id: item.line_id,
                            product_id: item.product_id,
                            pack_id: item.pack_id,
                            batch: item.batch,
                            expired_date: item.expired_date,
                            qty: item.qty,
                            uom_id: item.uom_id,
                            stock_type_id: item.stock_type_id,
                            base_uom_id: item.base_uom_id,
                            data_status: item.data_status,
                        })
                    }
                })

                return details
            },
            fetchAllData() {
                this.isLoading = true
                Promise.all([
                    this.$http.get('outbound/outbounddelivery/show/' + this.$route.params.id),
                    this.$http.post('master/stocktypes'),
                    this.$http.get('master/ordersources'),
                ])
                .then(this.$http.spread((outbound, stocktypes, ordersources) => {
                    this.stock_type.data = stocktypes.data.data
                    this.order_source.data = ordersources.data
                    const od = outbound.data;

                    this.data.id = od.id;
                    this.data.outbound_reference = od.outbound_reference;
                    this.data.req_del_date = od.req_del_date;
                    this.data.client_id = od.client.id;
                    this.data.transporter_id = od.transporter.id;
                    this.data.service_type_id = od.service_type.id;
                    this.data.order_source_id = od.order_source.id;
                    this.data.price = od.price;
                    this.data.business_type_id = od.business_type.id;
                    this.data.origin_id = od.origin.id;
                    this.data.origin_address_1 = od.origin.address_1;
                    this.data.origin_address_2 = od.origin.address_2;
                    this.data.destination_id = od.destination.id;
                    this.data.destination_address_1 = od.destination.address_1;
                    this.data.destination_address_2 = od.destination.address_2;
                    this.data.order_type_id = od.order_type.id;
                    this.data.status = od.status.name;
                    this.data.po_reference = od.po_reference;
                    this.data.po_date = od.po_date;
                    this.data.remark = od.remark;
                    this.data.custom.aju_number = od.custom.aju_number;
                    this.data.custom.sppb_number = od.custom.sppb_number;
                    this.data.custom.sppb_date = od.custom.sppb_date;
                    this.data.custom.blorawb = od.custom.blorawb;
                    this.data.custom.registration_number = od.custom.registration_number;
                    this.data.custom.registration_date = od.custom.registration_date;
                    this.data.custom.invoice_number = od.custom.invoice_number;
                    this.data.custom.nokendaraan = od.custom.nokendaraan;
                    this.data.custom.namasupir = od.custom.namasupir;
                    this.data.custom.nohp = od.custom.nohp;
                    this.data.details = [];

                    this.customer.data = this.$_.uniqBy(this.$_.compact([od.origin, od.destination]), i => i.id);
                    this.client.data.push(od.client);
                    this.order_type.data.push(od.order_type);
                    this.transporter.data.push(od.transporter);
                    this.service_type.data.push(od.service_type);
                    this.order_source.data.push(od.order_source);
                    this.business_type.data.push(od.business_type);

                    if(od.order_source) {
                        this.data.order_source_id = od.order_source.id;
                        //this.order_source.data.push(od.order_source);
                    }

                    if (od.payment_type) {
                        this.data.payment_type_id = od.payment_type.id;
                        this.payment_type.data.push(od.payment_type);
                    }

                    let warehouses = [];
                    let products = [];
                    od.details.map(detail => {
                        if(this.warehouse.data.findIndex(w => w.id == detail.warehouse.id) === -1) {
                            this.warehouse.data.push(detail.warehouse)
                        }

                        if(this.products.findIndex(w => w.id == detail.product.id) === -1) {
                            this.products.push(detail.product)
                        }

                        this.data.details.push({
                            id: detail.id,
                            line_id: detail.line_id,
                            warehouse_id: detail.warehouse.id,
                            product_id: detail.product.id,
                            description: detail.product.description_1,
                            pack_id: detail.pack_id,
                            batch: detail.batch,
                            expired_date: detail.expired_date,
                            qty: detail.qty,
                            uom_id: detail.uom.id,
                            stock_type_id: detail.stock_type.id,
                            committed_qty: detail.committed_qty,
                            base_qty: detail.base_qty,
                            base_uom_id: detail.product.base_uom.id,
                            uoms: detail.product.uoms,
                            data_status: 'update'
                        });
                    })

                    this.isLoading = false
                }))
                .catch(e => {
                    console.log(e)

                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => this.$router.push({name: 'outbound-delivery'}),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })
            },
            removeDetail(){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Warning`,
                    text: `Are you sure want to delete ${this.selected.length} line?`,
                    accept: () => {
                        let indexes = []
                        let selected = this.selected.map(i => i.line_id);

                        selected.map(item => {
                            const index = this.data.details.findIndex(c => c.line_id == item)
                            const del = this.data.details[index];
                            if(del) {
                                this.data.details.splice(index, 1);
                                // if(del.data_status == 'insert') {
                                    // this.data.details.splice(index, 1);
                                // }
                                // else {
                                //     del.data_status = 'delete';
                                // }
                            }
                        })

                        this.assignLineId()
                        this.selected = [];
                    }
                })
            },
            addItem() {
                const addLine = () => {
                    this.data.details.push({
                        id: 0,
                        line_id: null,
                        warehouse_id: this.$store.state.user.userconfig.warehouse_id ? this.$store.state.user.userconfig.warehouse_id : null,
                        product_id: null,
                        description: '',
                        pack_id: null,
                        batch: null,
                        expired_date: null,
                        qty: '',
                        uom_id: null,
                        stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                        committed_qty: 0,
                        base_qty: '',
                        base_uom_id: null,
                        uoms: [],
                        data_status: 'insert',
                    })

                    this.assignLineId()
                }

                if(!this.data.details.length) {
                    this.isLoading = true
                    this.$http.post('master/product/showbyclient', { client_id: this.data.client_id })
                    .then(res => {
                        this.products = []
                        this.isLoading = false

                        res.data.data.map(item => {
                            const uoms = item.uoms.map(uom => {
                                return {
                                    id: uom.uom_id,
                                    name: uom.uom.name,
                                    numerator: uom.numerator,
                                    denominator: uom.denominator,
                                }
                            })

                            this.products.push({
                                id: item.id,
                                product_code: item.product_code,
                                description_1: item.description_1,
                                uoms: item.uoms.map(uom => {
                                    return {
                                        id: uom.uom.id,
                                        name: uom.uom.name,
                                        numerator: uom.numerator,
                                        denominator: uom.denominator
                                    }
                                }),
                                base_uom: {
                                    id: item.base_uom.uom.id,
                                    name: item.base_uom.uom.name,
                                }
                            })
                        })

                        addLine();
                    })
                    .catch(error => this.handleError(error))
                }
                else {
                    addLine();
                }
            },
            convertQty(detail){
                const index = detail.uoms.findIndex(c => c.id == detail.uom_id)

                if(index !== -1) {
                    const uom = detail.uoms[index];
                    detail.base_qty = (detail.qty / uom.denominator) * uom.numerator
                }
            },
            validateQty(detail) {
                if(detail.base_qty < 1) {
                    detail.qtyError = true
                }
                else {
                    detail.qtyError = false
                }
            },
            setOrigin() {
                const index = this.customer.data.findIndex(c => c.id == this.data.origin_id)
                if(index !== -1) {
                    this.data.origin_address_1 = this.customer.data[index].address_1;
                    this.data.origin_address_2 = this.customer.data[index].address_2;
                }
            },
            setDestination() {
                const index = this.customer.data.findIndex(c => c.id == this.data.destination_id)
                if(index !== -1) {
                    this.data.destination_address_1 = this.customer.data[index].address_1;
                    this.data.destination_address_2 = this.customer.data[index].address_2;
                }
            },
            editForm() {
                if(this.editable) {
                    this.edit.req_del_date = true
                    this.edit.order_type = true
                    this.edit.origin = true
                    this.edit.destination = true
                    this.edit.client = true
                }

                this.editMode = true
                this.edit.reference = true
                this.edit.po_reference = true
                this.edit.po_date = true

                this.data.outbound_delivery_details.map(item => {
                    if(item.committed_qty == 0) {
                        item.edit.warehouse = true
                        item.edit.product = true
                        item.edit.pack_id = true
                        item.edit.batch = true
                        item.edit.expired_date = true
                        item.edit.stock_type = true
                        item.edit.uom = true
                    }
                })
            },
            clientChange() {
                if(this.data.details.length) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Confirmation',
                        text: 'Changing client will remove details, continue?',
                        accept: () => {
                            this.data.details = []
                            this.products = []
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                }
            },
            createDo() {
                this.isLoading = true
                const dataSend = {
                    'id': this.$route.params.id,
                }

                this.$http.post('outbound/outbounddelivery/createdo', dataSend)
                .then(res => {
                    this.isLoading = false

                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Click here to view delivery order',
                        time: 4000,
                        click: () => {
                            this.$router.push({
                                name: 'delivery-order-view',
                                params: {
                                    id: res.data.id
                                }
                            })
                        }
                    })

                })
                .catch(error => {
                    this.isLoading = false

                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'

                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            },
            assignLineId() {
                let lineId = 1
                this.data.details.map((detail, index) => {
                    detail.line_id = lineId
                    lineId++
                })
            },
            printOdNote() {
                this.isLoading = true
                const id = [this.$route.params.id]
                this.$http.post('outbound/outbounddelivery/report/outbound_note', {id: id}, {responseType: 'blob'})
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .then(() => this.isLoading = false)
            },
            searchProductClient(e) {
                this.$http.post('master/product/showbyclient', { client_id: this.data.client_id, product_code: e.target.value })
                .then(res => {
                    res.data.data.map(item => {
                        if(this.products.findIndex(p => p.id === item.id) === -1) {
                            this.products.push({
                                id: item.id,
                                product_code: item.product_code,
                                description_1: item.description_1,
                                uoms: item.uoms.map(uom => {
                                    return {
                                        id: uom.uom.id,
                                        name: uom.uom.name,
                                        numerator: uom.numerator,
                                        denominator: uom.denominator
                                    }
                                }),
                                base_uom: {
                                    id: item.base_uom.uom.id,
                                    name: item.base_uom.uom.name,
                                }
                            })
                        }
                    })
                })
            },
            getProduct(detail) {
                const data = this.products[this.products.findIndex(p => p.id === detail.product_id)]
                detail.uoms = data.uoms

                detail.description = data.description_1
                detail.uom_id = data.base_uom.id
                detail.base_uom_id = data.base_uom.id

                if(!detail.base_qty) {
                    detail.base_qty = 1
                    detail.qty = 1
                }
                else {
                    detail.base_qty = detail.qty
                }
            },
        },
        mounted(){
            this.fetchAllData()
            this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachments = res.data.result
        });
        },
	}
</script>
